<template>
    <div class="App_box">
          <portalIndex></portalIndex>
    </div>
  </template>
  
  <script>
  import portalIndex from './views/portal/portalIndex.vue';
  export default {
    name: 'app',
    components: {
      portalIndex
    },
    data(){
      return {
          
      } 
    },
      created(){
          
      },
      watch: {
          
      },
      beforeUnmount(){
          
      },
      mounted() {
        
      },
      methods:{
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .App_box{
      width:100%;
      height:100%;
  }
  </style>
  